import { forwardRef } from "react";
import { cssModule, mergeProps, normalizeSize } from "../../shared";
import { StyleProvider, useResponsiveValue, useStyleProps } from "../../styling";
import { Text } from "../../typography";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "p";
export function InnerParagraph(props) {
  const [styleProps] = useStyleProps("p");
  const {
    as = DefaultElement,
    children,
    forwardedRef,
    size,
    ...rest
  } = mergeProps(props, styleProps);
  const sizeValue = useResponsiveValue(size);
  return /*#__PURE__*/_jsx(Text, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-p", sizeValue && sizeValue === "inherit" ? "inherit-size" : normalizeSize(sizeValue)),
      ref: forwardedRef,
      size: sizeValue
    }),
    children: /*#__PURE__*/_jsx(StyleProvider, {
      value: {
        link: {
          size: "inherit"
        }
      },
      children: children
    })
  });
}
InnerParagraph.defaultElement = DefaultElement;
export const Paragraph = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerParagraph, { ...props,
  forwardedRef: ref
}));